"use client";

import React, { createContext } from "react";

export enum TaskActionType {
  NEWTASK = 1,
  UPDATETASK = 2,
  VIEWTASK = 3,
}

interface TaskContextType {
  taskAction: TaskActionType | null;
  onOpenTaskSideSheet: () => void;
  handleUpdateFormResultID: (formResultID: string) => void;
  onTaskAction: (action: TaskActionType) => void;
  openTaskSideSheet: boolean;
  onTaskID: (value: string) => void;
  taskID: string;
  formResultID: string;
}

interface Props {
  children: React.ReactNode;
}

export const TaskContext = createContext<TaskContextType | null>(null);

export const TaskContextProvider: React.FC<Props> = ({ children }) => {
  const [formResultID, setFormResultID] = React.useState<string>("0");
  const [taskID, setTaskID] = React.useState<string>("");
  const [taskAction, setTaskAction] = React.useState<TaskActionType | null>(
    null
  );
  const [openTaskSideSheet, setOpenTaskSideSheet] =
    React.useState<boolean>(false);

  const onOpenTaskSideSheet = () => {
    setOpenTaskSideSheet(!openTaskSideSheet);
  };

  const onTaskAction = (action: TaskActionType) => {
    setTaskAction(action);
  };
  const onTaskID = (value: string) => {
    setTaskID(value);
  };

  const handleUpdateFormResultID = (inputValue: string) => {
    setFormResultID(inputValue);
  };

  return (
    <TaskContext.Provider
      value={{
        onOpenTaskSideSheet,
        taskAction,
        onTaskAction,
        openTaskSideSheet,
        taskID,
        onTaskID,
        handleUpdateFormResultID,
        formResultID,
      }}
    >
      {children}
    </TaskContext.Provider>
  );
};
